export default "__VITE_ASSET__DqwuTc4l__"